import React from 'react';

import Navigation from './Navigation'
import MetaData from './MetaData'
// import Notification from './Notification'
// import LoginTrigger from "../authorization/LoginTrigger"


const Index = (props) => {

  return(
    <React.Fragment>
			<MetaData />
			<Navigation />
			{/*<Notification /> 
			<LoginTrigger />*/}
    </React.Fragment>
  )
}

export default Index
